import React, { useState } from 'react';
import SuperSearchList from '../../../shared/SuperSearch/SuperSearchList';
import { useEffect } from 'react';
import { ServerRequestProtected } from '../../../../utils/ServerDataRequest';
import { enumUtil } from '../../../../utils/Enum';
import isNull from '../../../../utils/NullChecking';
import NoDataFound from '../../../shared/NoDataFound/NoDataFound';
import Loader from '../../../shared/Loader/Loader';
import NotificationHandler from '../../../../utils/NotificationHandler';
// import isNull from '../../../../utils/NullChecking';

const Enrollment = (props) => {
  const { InsuranceID } = { ...props }
  const API_URL_General = enumUtil.controller.General
  const API_URL_Integration = enumUtil.controller.Integration
  const isLive = process.env.REACT_APP_ISLIVE


  const [dropdownOption, setDropdownOption] = useState([])
  const [isLoading, setIsLoading] = useState(false);

  const [mainmodel, setmaimodel] = useState({
    payerID: "",
    enrollment: "",
    display: ""
  })
  const [url, setUrl] = useState("")


  useEffect(() => {
    setIsLoading(true)
    ServerRequestProtected(API_URL_General + "/DropDown", 'post', {
      "TableName": enumUtil.enumAPITableName.Insurance,
      "ID": InsuranceID
    })
      .then((response) => {
        setIsLoading(false)

        setDropdownOption(response)
        // webBrown(response?.[0], "Useffect")
        setmaimodel({ ...mainmodel, payerID: response?.[0].value, enrollment: response?.[0].Enroll, display: response?.[0].display })
      }).catch((error) => {
        setIsLoading(false)
      })

  }, [])

  const webBrown = (data, type) => {
    if (isLive === 'true') {
      setIsLoading(true)
      ServerRequestProtected(API_URL_Integration + "/GetEnrollProvider", 'post', {
        // "Payerid":"CPHL0",
        // "Enroll":"era"
        "Payerid": data.payerID,
        "Enroll": data.enrollment
      })
        .then((response) => {
          setIsLoading(false)
          setUrl(response?.result?.link?.["@url"])
        }).catch((error) => {
          setIsLoading(false)
        })
    } else {
      NotificationHandler("Can't use in Local ", enumUtil.enumtoaster.error);
    }
  }

  useEffect(() => {
    if (mainmodel.enrollment !== "") {
      webBrown(mainmodel, 'onchange');
    }
  }, [mainmodel.enrollment]);



  const handleChange = (e) => {
    let { name, value } = e.target
    if (name === 'payerID') {
      setmaimodel({ ...mainmodel, enrollment: value })
    }
  }
  const handleSelectedDataa = (selectedData, name, type) => {


    if (type === 'client' && !isNull(selectedData)) {

      if (name === 'PayerID') {
        setmaimodel({ ...mainmodel, payerID: selectedData.value + "", enrollment: selectedData.Enroll + "", display: selectedData.display })
      }
    } else {
    }
    return selectedData
  }
  return (
    <>
      {isLoading ? <Loader /> : null}
      <div className="ar-fee_setup m-0 mt-3 position-relative row">
        <div className="col-md-3 px-0">
          <div className='input form-group'>
            <SuperSearchList
              type="client"
              id='PayerID'
              name='PayerID'
              data={dropdownOption}
              searchValue={mainmodel.display}
              // data={ClaimTypeDD}
              onChange={(e) => handleChange(e)}
              getSelectedData={handleSelectedDataa}
              sup_btn='sup_btn-Inp'
              sup_inp='superSearchVisitInp'
            />
          </div>
        </div>
        {isNull(url) ? (
          <NoDataFound isLoading={isLoading} rows={[]} />
        ) :
          <iframe
            src={url}
            width="100%"
            height="600px"
            title="Embedded Browser"
          />
        }

      </div>
    </>
  )
}

export default Enrollment;